



















































































































import Vue from "vue";
import DateInput from "@/components/DateInput.vue";
import ApiSearch from "@/components/apiSearch/models/ApiSearch";
import { FilteringModel } from "@/services/filtering";
import { CurrentAccountPreAccLookups } from "../models/CurrentAccountPreAccounting";

/**
 * K2D dw_status::retrieveend — a pipa a törzs MINDEN élő státuszára bekerül, kivéve a
 * 4 (Feladva), 6 (Fők. rendsz. feladva) és 9 (Nem feladandó). Ezért nem fix listát
 * tartunk, hanem a lookupból (ssaccaccstatus, szam <> 1 és élő) vonjuk ki ezt a hármat —
 * így ha a törzsbe új státusz kerül, a böngésző a K2D-vel együtt mozog.
 */
const UNCHECKED_STATUSES = ["4", "6", "9"];

/** Ha a törzs nem tölthető be, ez a lista áll be — a mai ssaccaccstatus élő státuszai 4/6/9 nélkül */
const FALLBACK_STATUSES = ["2", "3", "5", "7", "8"];

interface Data {
  ready: boolean;
  awaitingLookups: boolean;
}

interface Methods {
  ensureFilters(): void;
  applyStatusDefaults(): void;
}

interface Computed {
  filters: any;
  accStatusOptions: any[];
  onlyCurrentAccount: boolean;
}

interface Props {
  apiSearch: ApiSearch;
  lookups: CurrentAccountPreAccLookups | null;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    DateInput,
  },

  props: {
    apiSearch: { type: Object as () => ApiSearch },
    lookups: { type: Object as () => CurrentAccountPreAccLookups | null, default: null },
  },

  data() {
    return {
      ready: false,
      awaitingLookups: false,
    };
  },

  created() {
    this.ensureFilters();
  },

  watch: {
    // A törzsadat (lookups) a szülő beforeMount()-jában ASZINKRON töltődik, és a gyakorlatban
    // MINDIG később ér célba, mint ennek a komponensnek a created()-je (a szinkron mountolás
    // nem várja meg egy async hívás visszatérését) — ezért a K2D-alapállapotot NEM a created()-
    // ben, hanem itt, a lookups tényleges megérkezésekor számoljuk (ld. applyStatusDefaults).
    lookups(value: CurrentAccountPreAccLookups | null) {
      if (value && this.awaitingLookups) this.applyStatusDefaults();
    },
  },

  methods: {
    ensureFilters() {
      const filter = (this.$props.apiSearch as any).filter as FilteringModel;
      if (!filter) return;

      // A default-értékek beírása INDÍTJA a lista első betöltését: a view az
      // ApiSearchPage automatikus első lekérdezését kikapcsolta (:autoLoad="false"),
      // mert az még a szűrőpanel létrejötte ELŐTT futna, alapértékek nélkül. Az
      // ApiSearchPage deep-watchere az itt írt értékekre indítja az egyetlen kérést.

      const template = new FilteringModel()
        .value("accDateFrom")
        .value("accDateTo")
        .value("insDateFrom")
        .value("insDateTo")
        .multiSelect("selectedAccStatuses", [], false)
        .value("onlyCurrentAccount")
        .value("itemPartnerName")
        .value("itemPrefix")
        .value("itemInvoice");

      let statusesCreated = false;
      Object.entries(template.filters).forEach(([key, value]) => {
        if (!filter.filters[key]) {
          Vue.set(filter.filters, key, value);
          if (key === "selectedAccStatuses") statusesCreated = true;
        }
      });

      if (this.filters.onlyCurrentAccount.value == null) this.filters.onlyCurrentAccount.value = "1";

      if (statusesCreated) {
        if (!this.$props.lookups) {
          // A törzs még nem érkezett meg — a watcher alkalmazza az alapértéket, amint
          // megjön, hogy a lista ELSŐ lekérdezése már a valódi törzsből számolt pipákkal
          // induljon (nem a — könnyen elavuló — FALLBACK_STATUSES-szal).
          this.awaitingLookups = true;
          return;
        }
        this.applyStatusDefaults();
        return;
      }

      this.ready = true;
      this.$emit("filters-ready");
    },

    // K2D-alapállapot: a státusz-pipák CSAK a szűrő létrejöttekor kapják az alapértéket
    // (4, 6, 9 kikapcsolva) — a felhasználó által kiürített lista üres marad, ami a
    // K2D-ben is üres találatot ad (IN (-1)). A FALLBACK_STATUSES csak akkor él, ha a
    // törzs ténylegesen üresen/hibásan érkezett (a szülő ilyenkor is beállítja a
    // lookups propot, ld. CurrentAccountPreAccActionsView.vue beforeMount catch ága).
    applyStatusDefaults() {
      const fromLookup = this.accStatusOptions
        .map((x: any) => x.value)
        .filter((x: string) => !UNCHECKED_STATUSES.includes(x));
      this.filters.selectedAccStatuses.selectedOptions =
        fromLookup.length > 0 ? fromLookup : [...FALLBACK_STATUSES];
      this.awaitingLookups = false;

      this.ready = true;
      // A lista első betöltését a view indítja, most már a K2D alapértékekkel
      // (az ApiSearchPage automatikus első lekérdezése ezért van kikapcsolva)
      this.$emit("filters-ready");
    },
  },

  computed: {
    filters(): any {
      return (this.$props.apiSearch as any).filter?.filters ?? {};
    },

    accStatusOptions(): any[] {
      return (this.$props.lookups?.accStatuses ?? []).map((x: any) => ({
        text: x.name,
        value: String(x.id),
      }));
    },

    // A kapcsoló a szűrőmodellben "1"/"0"-ként utazik; hiányzó érték = bekapcsolt (K2D default)
    onlyCurrentAccount: {
      get(): boolean {
        const raw = this.filters.onlyCurrentAccount?.value;
        return raw == null || raw !== "0";
      },
      set(value: boolean) {
        if (this.filters.onlyCurrentAccount) this.filters.onlyCurrentAccount.value = value ? "1" : "0";
      },
    },
  },
});
